const module = 'USER_RESOURCES_'

export const SET_NETWORKS = module + 'SET_NETWORKS'
export const SET_NETWORKS_GROUPINGS = module + 'SET_NETWORKS_GROUPINGS'



// WEBPACK FOOTER //
// ./src/app/appLogic/networks/store/constants.js